"use client";

import { scrollToTop } from "@homeinstead/shared";
import Link from "next/link";
import Logo from "../Logo";

const NAV_BAR_LOGO_SVG_CLASS =
  "h-10 w-[123px] fill-friendly-base sm:h-12 sm:w-[148px] group-data-[appearance=campaign]/navbar:fill-new-beginnings-base";

type NavBarLogoLinkProps = {
  disableLogoLink?: boolean;
};

function NavBarLogoLink({ disableLogoLink = false }: NavBarLogoLinkProps) {
  if (disableLogoLink) {
    return (
      <button
        aria-label="Scroll to top"
        className="inline-block"
        onClick={scrollToTop}
        type="button"
      >
        <Logo className={NAV_BAR_LOGO_SVG_CLASS} />
      </button>
    );
  }

  return (
    <Link aria-label="Visit homeinstead corporate" href="/">
      <Logo className={NAV_BAR_LOGO_SVG_CLASS} />
    </Link>
  );
}

export { NavBarLogoLink };
